import React, { useEffect, useState } from 'react';
export function TopAnnouncementBar() {
  // Compact mm:ss countdown starting at 15:00 to mirror the reference vibe
  const [secondsLeft, setSecondsLeft] = useState(15 * 60);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const t = setInterval(() => setSecondsLeft(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(t);
  }, [secondsLeft]);
  const mm = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
  const ss = (secondsLeft % 60).toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-black border-b border-gold/20" data-id="element-594">
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-3 md:gap-4 text-center" data-id="element-595">
        <span className="hidden sm:inline-block w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" data-id="element-596" />
        <p className="text-xs md:text-sm text-white font-medium" data-id="element-597">
          <span className="text-gold font-extrabold" data-id="element-598">66% OFF</span>
          <span className="hidden sm:inline text-textsecondary" data-id="element-599">
            {' '}
            — solo hasta que el contador llegue a cero
          </span>
          <span className="sm:hidden text-textsecondary" data-id="element-600"> · oferta cierra</span>
        </p>
        <span className="inline-flex items-center font-mono font-bold text-sm md:text-base text-red-400 bg-red-500/10 border border-red-500/30 rounded-md px-2 py-0.5 tabular-nums" data-id="element-601">
          {mm}:{ss}
        </span>
      </div>
    </div>;
}